import { useState, useEffect } from "react";
import axios from "axios";
import { campuses as mockCampuses } from "../data/mock";

const CRM = process.env.REACT_APP_CRM_BACKEND;
const CRM_KEY = process.env.REACT_APP_CRM_API_KEY;

const normalizeCampus = (c) => ({
  id: c._id || c.id || String(c.name || "campus").toLowerCase().replace(/\s+/g, "-"),
  code: c.shortName || c.code || String(c.name || "TIPS").slice(0, 4).toUpperCase(),
  name: c.name || "TIPS Campus",
  area: c.area || c.location || c.city || "",
  address: c.address || "",
  phone: c.phone || c.contact_number || "",
  whatsapp: c.whatsapp || c.whatsapp_number || c.phone || c.contact_number || "",
  curricula: Array.isArray(c.programs) && c.programs.length > 0
    ? c.programs
    : Array.isArray(c.curricula) ? c.curricula : (c.curriculum ? [c.curriculum] : ["CBSE"]),
  featured: c.main || c.featured || c.is_featured || false,
  gradeRangeLabel: c.gradeRangeLabel || null,
  description: c.description || "",
  mapLink:
    c.map_url || c.mapLink || c.map_link ||
    `https://maps.google.com/?q=${encodeURIComponent((c.address || c.name || "TIPS") + " Bengaluru")}`,
});

let cachedCampuses = null;

const useCampuses = () => {
  const [campusList, setCampusList] = useState(cachedCampuses || mockCampuses);

  useEffect(() => {
    if (cachedCampuses) return;

    axios
      .get(`${CRM}/api/public/campuses/tipsblr`, { headers: { "X-API-Key": CRM_KEY } })
      .then((res) => {
        const raw = Array.isArray(res.data) ? res.data : [];
        // Strict: only campuses with address, phone AND shortName (excludes placeholder entries)
        // Also dedupe by name to prevent duplicate entries
        const seen = new Set();
        const valid = raw.filter((c) => {
          if (!c.address || !c.phone || !c.shortName) return false;
          if (seen.has(c.name)) return false;
          seen.add(c.name);
          return true;
        });
        if (valid.length > 0) {
          cachedCampuses = valid.map(normalizeCampus);
          setCampusList(cachedCampuses);
        }
      })
      .catch(() => {}); // silent fallback keeps mockCampuses
  }, []);

  return campusList;
};

export default useCampuses;